export default __webpack_public_path__ + "static/media/message.da717d15.jpg";